import type { ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AppThemeProvider } from './theme/AppThemeProvider'
import { queryClient } from './queryClient'

/**
 * Providerlar tartibi (xsib-selfcare naqshi, `AuthProvider` qatlamisiz —
 * bu ilovada login/sessiya YO'Q, mehmon har doim anonim):
 *
 *   Query → Theme → Router
 *
 * `AppThemeProvider` antd `App` ni beradi — xabar/modal undan pastdagi
 * hamma joyda ishlashi kerak.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <BrowserRouter>{children}</BrowserRouter>
      </AppThemeProvider>
    </QueryClientProvider>
  )
}
